import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

interface DisclaimerStepProps {
    onAccept: () => void;
}

export const DisclaimerStep = ({ onAccept }: DisclaimerStepProps) => {
    const { t } = useTranslation();
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
            <div className="mx-4 max-w-md rounded-lg bg-background p-6 shadow-xl sm:p-8">
                <h2 className="mb-4 text-lg font-semibold dark:text-white">{t('chat.onboarding.disclaimer.title')}</h2>
                <p className="mb-6 text-sm text-muted-foreground">
                    {t('chat.onboarding.disclaimer.body')}
                </p>
                <Button
                    onClick={onAccept}
                    className="w-full rounded-full"
                    data-track-click="AI Chat Disclaimer Accepted"
                    data-track-location="ai-chat"
                    data-track-button-name="ai-chat-disclaimer-accept"
                >
                    {t('chat.onboarding.disclaimer.accept')}
                </Button>
            </div>
        </div>
    );
};
